import { render, staticRenderFns } from "./InqueryFinalized.vue?vue&type=template&id=210200c5&scoped=true&"
import script from "./InqueryFinalized.vue?vue&type=script&lang=ts&"
export * from "./InqueryFinalized.vue?vue&type=script&lang=ts&"
import style0 from "./InqueryFinalized.vue?vue&type=style&index=0&id=210200c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210200c5",
  null
  
)

export default component.exports